// extracted by mini-css-extract-plugin
export default {"isNested":"SideTabsLink_isNested__2+D1t"};